import { useState } from "react"

export const useOpenComponent = ( initialState = false ) => {
   const [showMenu, setShowMenu] = useState(initialState)
   const [value, setValue] = useState(0)
   const [isOpen, setIsOpen] = useState(false)
   const onCloseMenu = () => { // DO NOT USE THIS FUNCTION ANYMORE
      setShowMenu(!showMenu)
   }

   
   const handleIsOpen = () => {
      setIsOpen(!isOpen)
   }

   const onChange = (event, newValue) => {
      setValue(newValue);
    };

   
    //USE handleIsOpen and isOpen
   return { showMenu, onCloseMenu, onChange, value,handleIsOpen, isOpen }
}